import { gql } from 'graphql-request'

import { ScheduledCommunicationTypesQueries } from '../queries/scheduledCommunicationTypes.queries'

export namespace ScheduledCommunicationTypeMutations {
  export function createScheduledCommunicationType() {
    return gql`
      mutation createScheduledCommunicationType($scheduledCommunicationType: ScheduledCommunicationTypeInsertMutation) {
        createScheduledCommunicationType(scheduledCommunicationType: $scheduledCommunicationType) {
          id
          createdAt
          description
          active
          defaultToApproved
          leadTime
          timeToSend
        }
      }
    `
  }

  export function updateScheduledCommunicationType() {
    return gql`
      mutation updateScheduledCommunicationType($scheduledCommunicationType: ScheduledCommunicationTypeUpdateMutation) {
        updateScheduledCommunicationType(scheduledCommunicationType: $scheduledCommunicationType) {
          ...ScheduledCommunicationTypeSummary
        }
      }
      ${ScheduledCommunicationTypesQueries.SCHEDULED_COMMUNICATION_TYPE_SUMMARY}
    `
  }
}
